module.exports = "### 客户简介\r\n中国移动通信集团公司（简称“中国移动”）于 2000年4月20日成立，注册资本3,000亿元人民币，资产规模超过1.72万亿人民币，客户总数8.5亿，基站总数超300万个，是全球网络规模、客户规模最大、市值排名领先的电信运营企业。"